import React, { useState } from "react"; 
import "./../styles/components/projects.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { MapPin } from "lucide-react";  // Location icon
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

// Images
import project1Img from "../assets/Divine Oak (2).png";
import project1ag from "../assets/divine oak.png";
import project1bmg from "../assets/DO.jpg";




import project3Img from "../assets/jdk.jpg";
import project3mg from "../assets/jdk1.jpg";    
import project3g from "../assets/jdk2.jpg";    

  
import project5Img from "../assets/SE3.jpg";  
import project5mg from "../assets/Se2.jpg";  



   

const projects = [
  {
    images: [project1Img, project1ag, project1bmg],
    title: "The Divine Oak",
    description: "A guest house built with elegance and strength.",
    place: "Katra",
    
    
  },
 
  {
    images: [project3Img,  project3mg,project3g],
    title: "Jain Ki Dukan ",
    description: "A general store designed for everyday needs.",
    place: "Delhi",
    
  },
  
   
  {
    images: [project5Img, project5mg],
    title: "Supreme Enclave",
    description: "Reinforcement work restoring strength and safety.",
    place: "Delhi",
    
  },
  
];

const ProjectSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isImageLoading, setIsImageLoading] = useState(true);

  const openLightbox = (images) => {
    setLightboxImages(images);
    setPhotoIndex(0);
    setIsImageLoading(true);
    setIsOpen(true);
  };

  return (
    <section id="projects" className="projects-section">
      <p className="projects-subtitle">Our Work</p>
      <h2 className="projects-title">Creating Spaces That Inspire</h2>
      <p className="projects-description">
        We deliver projects with scale, quality, and purity of work. Every structure, design, and detail reflects our dedication to excellence.
      </p>

      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        
        slidesPerView={3}
        navigation
        preventClicks={false}
        breakpoints={{
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
        className="projects-swiper"
      >
        {projects.map((project, index) => (
          <SwiperSlide
            key={index}
            className="project-card"
            onClick={() => openLightbox(project.images)}
            style={{ cursor: "pointer" }}
          >
            <img src={project.images[0]} alt={project.title} />
            <div className="project-content">
              <h4>{project.title}</h4>
              <p>{project.description}</p>
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="project-location"
              >
                <MapPin size={16} color="#ff6c00" />
                <span>{project.place}  {project.visit}</span>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="know-more-wrapper">
      <a href="#contact" className="know-more-btn">
        Know More →
      </a>
    </div>

      {isOpen && (
        <Lightbox
          mainSrc={lightboxImages[photoIndex]}
          nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
          prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % lightboxImages.length)
          }
          onImageLoad={() => setIsImageLoading(false)}
        >
          {isImageLoading && (
            <div className="custom-loading">
              <span>J</span>
              <span>V</span>
              <span>E</span>
              <span className="blink">.</span>
              <span className="blink">.</span>
              <span className="blink">.</span>
            </div>
          )}
        </Lightbox>
      )}

      {/* Corner decorations */}
      <span className="corner-bl"></span>
      <span className="corner-br"></span>
    </section>
  );
};

export default ProjectSection;
